import { SVGProps } from 'react';

const SvgLocker = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="#292929"
      strokeWidth={2}
      d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"
    />
    <circle cx={12} cy={16} r={2} stroke="#292929" strokeWidth={2} />
    <path stroke="#292929" strokeLinecap="round" strokeWidth={2} d="M6 10V8a6 6 0 1 1 12 0v2" />
  </svg>
);
export default SvgLocker;
